export const offsetSkippedRows = (result, offset) => ({
  ...result,
  skipped: (result?.skipped || []).map((s) =>
    s.row ? { ...s, row: s.row + offset } : s,
  ),
});

export const skippedReasonLines = (skipped, limit = 8) =>
  (skipped || [])
    .slice(0, limit)
    .map((s) => (s.row ? `Row ${s.row}: ${s.reason}` : s.reason));

export const mergePreviews = (previews) =>
  previews.reduce(
    (acc, p, index) => ({
      columns: index === 0 ? p.columns : acc.columns,
      sample: index === 0 ? p.sample : acc.sample,
      counts: {
        rows: acc.counts.rows + (p.counts?.rows || 0),
        buyers: acc.counts.buyers + (p.counts?.buyers || 0),
        sellers: acc.counts.sellers + (p.counts?.sellers || 0),
        clients: acc.counts.clients + (p.counts?.clients || 0),
        skipped: acc.counts.skipped + (p.counts?.skipped || 0),
      },
      skipped: [...acc.skipped, ...(p.skipped || [])],
    }),
    {
      columns: [],
      sample: [],
      counts: { rows: 0, buyers: 0, sellers: 0, clients: 0, skipped: 0 },
      skipped: [],
    },
  );
